module.exports = __webpack_public_path__ + "img/ercode_phz.68313821.png";